// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bb556e5","396":"e26a3e61","453":"b7788b58","455":"0192d295","857":"dfd69546","977":"d9bb992c"}[chunkId] + ".chunk.js";
};